define.alias("shared/components/shared/appstore-links", "settings/components/shared/appstore-links");